module.exports = __webpack_public_path__ + "static/media/cs.05293256.png";